import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithTimeout from './baseQueryWithTimeout';

const getStaffPortalBaseUrl = (isV3ApiEnabled) => (isV3ApiEnabled ? '/api/v3/staffportal' : '/api/staffportal');
const getStaffPortalHeaders = (auth0Token, isV3ApiEnabled) => (isV3ApiEnabled ? { customAuthToken: auth0Token } : {});

export const premiumsAndPaymentApi = createApi({
  reducerPath: 'premiumsAndPaymentApi',
  baseQuery: baseQueryWithTimeout,
  endpoints: (builder) => ({
    validateStateWithOutstandingPremium: builder.mutation({
      query: (data) => ({
        url: `/api/staffportal/validateStateWithOutstandingPremium`,
        method: 'POST',
        body: data
      })
    }),
    getOutstandingPolicyPayment: builder.query({
      query: ({ policyNumber, partnerNumber, auth0Token, isV3ApiEnabled }) => ({
        url: isV3ApiEnabled
          ? `${getStaffPortalBaseUrl(isV3ApiEnabled)}/getpolicyoutstandingpayment/${policyNumber}`
          : `${getStaffPortalBaseUrl(isV3ApiEnabled)}/getpolicyoutstandingpayment/${policyNumber}/${partnerNumber}`,
        headers: getStaffPortalHeaders(auth0Token, isV3ApiEnabled)
      })
    }),
    validateOutstandingPolicyPayment: builder.mutation({
      query: (data) => ({
        url: '/api/staffportal/validateOutstandingPremiumRecord',
        method: 'POST',
        body: data
      })
    }),
    initiateWebCollection: builder.mutation({
      query: (data) => ({
        url: '/api/staffportal/Initiatewebcollection',
        method: 'POST',
        body: data
      })
    }),
    premiumPayment: builder.mutation({
      query: (data) => ({
        url: '/api/staffportal/PremiumPayment',
        method: 'POST',
        body: data
      })
    }),
    registerAccount: builder.mutation({
      query: (data) => ({
        url: '/api/payment/RegisterAccount',
        method: 'POST',
        body: data
      })
    }),
    insertInstalmentRecord: builder.mutation({
      query: (data) => ({
        url: '/api/payment/insertInstalmentRecord',
        method: 'POST',
        body: data
      })
    }),
    updatePremiumRecord: builder.mutation({
      query: (data) => ({
        url: '/api/payment/updatePremiumRecord',
        method: 'POST',
        body: data
      })
    })
  })
});

export const {
  useValidateStateWithOutstandingPremiumMutation,
  useLazyGetOutstandingPolicyPaymentQuery,
  useValidateOutstandingPolicyPaymentMutation,
  useInitiateWebCollectionMutation,
  usePremiumPaymentMutation,
  useRegisterAccountMutation,
  useInsertInstalmentRecordMutation,
  useUpdatePremiumRecordMutation
} = premiumsAndPaymentApi;
